<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
  

      

        <material-card
          color="green"
          title="Change Password"
        >

         <v-form  ref="form">

            
                  <v-container py-0>
                  <v-layout wrap>
                 
                    <v-flex class="md12">
                     	  <v-text-field v-model="obj.password"
                        v-validate="'required|min:8|max:16'"
                        name="password"
                        :error-message="errors.collect('password')"
                        type="password"
                        id="password"
                        aria-describedby="Password"
                        ref="password"  class="mt-4" placeholder="New Password"></v-text-field>
                    </v-flex>
                    <small class="text-danger">{{errors.first('password')}}</small>
                    
                    <v-flex class="md12">
                     	  <v-text-field v-model="obj.confirm_password"
                        v-validate="'required|min:8|max:16|confirmed:password'"
                        name="confirm"
                        :error-message="errors.collect('confirm')"
                        type="password"
                        id="confir."
                        aria-describedby="Confirm Password" class="mt-4" placeholder="Confirm Password" ></v-text-field>
                         <small class="text-danger">{{errors.first('confirm')}}</small>
                    </v-flex>  
                     

                    <v-flex
                      xs12
                      text-xs-right>
                      <v-btn  :disabled="!obj.password || !obj.confirm_password "
                        class="mx-0 font-weight-light"
                        color="success" @click="changePassword" >Change</v-btn>
                    </v-flex> 
                  </v-layout>
                </v-container>
                    
              </v-form>

        </material-card>

            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div> {{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
  
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
// import Form from '@/views/Form'
import xlsx from "xlsx";
export default {
  // components: {
  //   Form
  // },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('changePassword', []),
  },
  mounted () {
   
  },
  data () {
    return {
    thumbnailName: "",
    currentUser: {},
    obj: {},
    color: null,
    colors: ['warning'],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
    noticeMessage: '',
    }
  },
  created () {
     let cookie = null
    cookie = this.getCookie('Info')
    this.currentUser = JSON.parse(cookie)
  },
  methods: {
      ...mapActions("changePassword", [ "changeUserPassword"]),
    pickThumbnail() {
      this.$refs.thumbnail.click();
    },
    onThumbnailPicked(e) {
      this.thumbnailName = e.target.files[0].name;
    },
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i=0; i<ca.length; i++) {
          var c = ca[i].trim()
            if (c.indexOf(name)==0) return c.substring(name.length,c.length)
      }
      return "";
  },
    changePassword() {
     let loader = this.$loading.show({
              color: "green",
              canCancel: false,
              onCancel: this.onCancel,
              loader: 'dots',
              isFullPage: true
            });
            
     let obj = {       
        id: this.currentUser.id,
        password: this.obj.password
     }
   
   
     
      this.changeUserPassword(obj).then(response => {
        console.log(response)
         loader.hide()
        if (response.status == "OK") {       
         
          this.color = "success";        
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
          this.obj = {};
        } else {
          this.color = "warning";
          this.noticeMessage = "Warning! " + response.messages;
          this.snack("top");
        }
      
      }).catch(err => {
          console.log(err);
           loader.hide()
        });      
    },

    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }

      this.snackbar = true
    }
  }
}
</script>
